export const hasPrice = (price: number | null | undefined): price is number => {
  return typeof price === 'number' && Number.isFinite(price);
};

export const formatPrice = (price: number): string => {
  return `${price.toLocaleString('ru-RU')} ₽`;
};

export const formatItemPrice = (price: number | null | undefined): string => {
  return hasPrice(price) ? formatPrice(price) : 'Цена по запросу';
};
